import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack } from '@mui/material'

export default function EmailDialog({open,hideDialog,title,content,onSend, closeLabel='Close'}) {
  const [isSending, setIsSending] = useState(false)

  const wrapOnSend = async (e) => {
    e.preventDefault()
    setIsSending(true)
    await onSend(e)
    setIsSending(false)
  }

  return (
    <Dialog
      open={open}
      onClose={hideDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title" sx={{paddingBottom: 0}}>
        {title}
      </DialogTitle>
      <IconButton
          aria-label={closeLabel}
          onClick={hideDialog}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
      >
      <CloseIcon />
      </IconButton>
      <DialogContent>
      <Stack sx={{
          width: '100%',
          minWidth: { xs: '300px', sm: '360px', md: '400px' },
          gap: '1.5rem',
        }}>
        {content}
      </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={wrapOnSend} disabled={isSending}>
          {isSending ? <CircularProgress size={18} /> : <SendIcon />} <Box> &nbsp;Send</Box>
        </Button>
      </DialogActions>
    </Dialog>
  );
}